import React, { useContext, useEffect, useState } from "react";
import clss from "./DisasterListItem.module.css";
import { Box, Switch, Chip } from "@mui/material";
import { red } from "@mui/material/colors";
import axios from "axios";
import { sbHeightCtx } from "../../store/sidebarWiHeContext";
import PopoverBtn from "./PopoverBtn";
import DisasterSiteList from "./DisasterSiteList";
import RdvList from "./RdvList";

const DisasterListItem = (props) => {
  //console.log(props)
  let bgc = "";
  const { width } = useContext(sbHeightCtx);
  const [disasterSiteCount, setDisasterSiteCount] = useState(0);
  const [isStale, setIsStale] = useState(false);
  const isSelected = sessionStorage.onid == props.id;
  sessionStorage.onid == props.id ? (bgc = "lightgreen") : (bgc = "lightgrey");

  useEffect(() => {
    if (props.ox !== "1" || !props.dsid || !props.apiAddr) {
      setIsStale(false);
      return;
    }
    let cancelled = false;
    axios
      .get(
        `${props.apiAddr}/get/dsinferredmeta?dsid=${encodeURIComponent(props.dsid)}`,
      )
      .then((res) => {
        if (!cancelled) setIsStale(!!res.data?.isStale);
      })
      .catch(() => {
        if (!cancelled) setIsStale(false);
      });
    return () => {
      cancelled = true;
    };
  }, [props.ox, props.dsid, props.apiAddr]);

  const isActive = isSelected && props.ox === "1";
  return (
    <Box
      bgcolor={bgc}
      borderRadius={3}
      sx={{
        width: "100%",
        boxSizing: "border-box",
        marginBottom: 1,
        overflowX: "hidden",
        ...(isActive ? { border: "2px solid", borderColor: red[600] } : {}),
      }}
    >
      <li
        key={Math.random()}
        className={`${clss.meal} ${isSelected && props.ox === "1" ? clss.mealExpanded : ""}`}
        style={{ width: "100%" }}
      >
        <div className={clss.contentArea}>
          <h4>
            {props.name}
            {isStale && (
              <Chip
                label="미종료"
                size="small"
                color="warning"
                sx={{ ml: 0.5, height: 20, fontSize: "0.65rem" }}
              />
            )}
          </h4>
          <div className={clss.inputdate}>{props.ipdt}</div>
          <div className={clss.inputdate}>{props.addr}</div>
        </div>
        <div className={clss.buttonContainer}>
          {isActive && (
            <Box sx={{ display: "flex", alignItems: "center", marginRight: 1 }}>
              <Switch
                size="small"
                checked={props.soloDisasterId != null && String(props.soloDisasterId) === String(props.id)}
                onChange={(e) => props.onSoloChange(e.target.checked ? props.id : null)}
                title={props.soloDisasterId != null && String(props.soloDisasterId) === String(props.id) ? "해당 재난만 보기 해제" : "해당 재난만 보기"}
              />
            </Box>
          )}
          <PopoverBtn
            ingox={props.ox}
            id={props.id}
            name={props.name}
            ipdt={props.ipdt}
            addr={props.addr}
            dsid={props.dsid}
            lat={props.lat}
            lon={props.lon}
            onDataChanged={props.onDataChanged}
            apiAddr={props.apiAddr}
            onStatus={props.onStatus}
            onSelectDS={props.onSelectDS}
            hdmf={props.hdmf}
            mapfresh={props.mapfresh}
            onCollapsePanel={props.onCollapsePanel}
          />
        </div>
      </li>
      {isSelected && props.ox === "1" && (
        <Box sx={{ pt: 0.5, pb: 0.5, px: 0.5 }}>
          <DisasterSiteList
            apiAddr={props.apiAddr}
            mapfresh={props.mapfresh}
            onSelectDS={props.onSelectDS}
            onSitesCountChange={setDisasterSiteCount}
            sx={{ marginBottom: 0 }}
          />
          <RdvList
            apiAddr={props.apiAddr}
            dsid={props.dsid}
            dsnm={props.name}
            mapfresh={props.mapfresh}
            onShowRDV={props.onShowRDV}
            startOrderNumber={disasterSiteCount}
          />
        </Box>
      )}
    </Box>
  );
};

export default DisasterListItem;
